export type SearchMeta = {
  query: string;
  totalCount: number;
  resultCount: number;
  totalPages: number;
  latencyMs: number;
  page: number;
  limit: number;
};

export type SearchResponse<T> = {
  data: T[];
  meta: SearchMeta;
};

export type SearchHighlight = {
  field?: string;
  snippet: string;
};

export function toSearchMeta(
  value: unknown,
  defaults: Partial<SearchMeta> = {}
): SearchMeta {
  const source =
    value && typeof value === "object" && !Array.isArray(value)
      ? (value as Record<string, unknown>)
      : {};

  const asNumber = (input: unknown, fallback: number) => {
    if (typeof input === "number" && Number.isFinite(input)) return input;
    if (typeof input === "string" && input.trim()) {
      const parsed = Number(input);
      if (Number.isFinite(parsed)) return parsed;
    }
    return fallback;
  };

  return {
    query:
      typeof source.query === "string"
        ? source.query
        : (defaults.query ?? ""),
    totalCount: Math.max(
      0,
      Math.floor(asNumber(source.totalCount, defaults.totalCount ?? 0))
    ),
    resultCount: Math.max(
      0,
      Math.floor(asNumber(source.resultCount, defaults.resultCount ?? 0))
    ),
    totalPages: Math.max(
      0,
      Math.floor(asNumber(source.totalPages, defaults.totalPages ?? 0))
    ),
    latencyMs: Math.max(
      0,
      Math.floor(asNumber(source.latencyMs, defaults.latencyMs ?? 0))
    ),
    page: Math.max(1, Math.floor(asNumber(source.page, defaults.page ?? 1))),
    limit: Math.max(
      1,
      Math.floor(asNumber(source.limit, defaults.limit ?? 10))
    ),
  };
}
